import { Skeleton } from '@/components/EventCard/Skeleton';

export const EventCardsListSkeleton = () => {
  return (
    <div className='mb-6 mt-4 grid grid-cols-1 min-[500px]:grid-cols-2 gap-4 py-4 md:grid-cols-3 md:gap-6 lg:grid-cols-4 w-full'>
      {Array.from({ length: 4 }, () => crypto.randomUUID()).map((id) => (
        <Skeleton key={`event-card-skeleton-${id}`} />
      ))}
    </div>
  );
};
